/* eslint-disable @stylistic/quotes */
import { ShieldX } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '../utils/routing';

const FORBIDDEN_MESSAGES = [
  'Nope! Access denied. Did you forget your admin hat? 🎩',
  '403: Forbidden. Try asking nicely... or becoming an admin. 🙏',
  "Sorry! This page is for VIPs only. You're more of a... guest. 👋",
  'Access denied! Even our intern has more permissions than this. 🤷',
  'You shall not pass! (Without proper permissions) ⚔️',
  'Error 403: This door requires a special key. You have... keys to your apartment. 🔑',
  'Whoops! Looks like you took a wrong turn at Albuquerque. 🗺️',
  'This content is classified. Your clearance level: Not Quite There Yet. 🕵️',
  "403 Forbidden: Like a nightclub, but for data. You're not on the list. 📋",
  'Access denied! Have you tried turning yourself off and on again? 🔌',
  'Hold up! This area is restricted to admins, operators, and really convincing robots. 🤖',
  "Sorry pal, this page requires permissions you just don't have. It's not personal... it's just business. 💼",
  "Error 403: You're about 2-3 permission levels short. Better luck next time! 🎯",
  'Forbidden! This page is guarded by a digital dragon. You need the +5 Admin Sword. 🐉',
  'Access denied! Your credentials are valid, but your ambitions are too high. 🚀',
  "403: You can't sit with us! (Regina George, probably) 💅",
  "This page is invite-only. Check back when you're promoted! 📈",
  "Nuh-uh! These aren't the permissions you're looking for. 👋✨",
  'Forbidden zone! Trespassers will be... shown this error message. 🚫',
  "Error 403: Nice try, but we've seen better attempts from the office printer. 🖨️",
];

export const ForbiddenPage: React.FC = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const randomMessage = FORBIDDEN_MESSAGES[Math.floor(Math.random() * FORBIDDEN_MESSAGES.length)];
    setMessage(randomMessage);
  }, []);

  return (
    <div className='flex min-h-screen items-center justify-center bg-gradient-to-br from-background to-muted p-4'>
      <div className='w-full max-w-2xl text-center'>
        <div className='mb-8 flex justify-center'>
          <div className='rounded-full bg-destructive/10 p-8'>
            <ShieldX className='h-24 w-24 text-destructive' strokeWidth={1.5} />
          </div>
        </div>

        <h1 className='mb-4 text-6xl font-bold text-foreground'>403</h1>

        <h2 className='mb-4 text-2xl font-semibold text-foreground'>Access Forbidden</h2>

        <p className='mb-8 text-lg text-muted-foreground'>{message}</p>

        <div className='mb-8 rounded-lg border border-border bg-card p-6'>
          <p className='text-sm text-muted-foreground'>
            You don't have the required permissions to access this resource. If you believe this is
            a mistake, please contact your administrator.
          </p>
        </div>

        <div className='flex flex-col items-center justify-center gap-4 sm:flex-row'>
          <Link
            to={PATHS.dashboard}
            className='inline-flex h-10 items-center justify-center rounded-md bg-primary px-6 text-sm font-medium text-primary-foreground ring-offset-background transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          >
            Go to Dashboard
          </Link>

          <button
            onClick={() => {
              window.history.back();
            }}
            className='inline-flex h-10 items-center justify-center rounded-md border border-input bg-background px-6 text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};
